'use client';

import { isCrossZoneHref } from '@/lib/zones';
import NextLink, { LinkProps as NextLinkProps } from 'next/link';
import React, { FC, PropsWithChildren } from 'react';

export interface LinkProps
  extends Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, keyof NextLinkProps>,
    NextLinkProps,
    React.RefAttributes<HTMLAnchorElement>,
    PropsWithChildren {}

const Link: FC<LinkProps> = ({ children, href, prefetch, replace, scroll, shallow, ...anchorProps }) => {
  /*
   * Paths owned by another zone can't be soft-navigated to, so let the browser load them.
   * See https://nextjs.org/docs/pages/guides/multi-zones#linking-between-zones
   */
  if (typeof href === 'string' && isCrossZoneHref(href)) {
    return (
      <a {...anchorProps} href={href} data-regular-link="true">
        {children}
      </a>
    );
  }

  return (
    <NextLink
      {...anchorProps}
      href={href}
      prefetch={prefetch}
      replace={replace}
      scroll={scroll}
      shallow={shallow}
    >
      {children}
    </NextLink>
  );
};

export default Link;
